const VectorSearchBelowRating = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="341"
    height="26"
    viewBox="0 0 341 26"
    fill="none"
    preserveAspectRatio="none"
  >
    <path
      d="M18.0139 15.6092L0 16.6792V26H341V16.6792H122.986C118.632 16.6792 114.465 14.9042 111.448 11.7639L108.159 8.33962L103.688 3.68654C101.426 1.33125 98.3008 0 95.0348 0H44.4566C41.3166 0 38.3018 1.23073 36.0588 3.42813L32.5 6.91468L28.2622 11.0665C25.5056 13.767 21.866 15.3803 18.0139 15.6092Z"
      fill="white"
    />
  </svg>
);

export default VectorSearchBelowRating;
